import { inject } from 'inversify';

import { service } from '@/decorators/service';
import { SignalrListener, SignalrMessage } from '@/decorators/signalr';
import { GenderStore } from '@/stores/GenderStore';
import { mapValueProperty } from '@/utils/mapValueProperty';
import type { IGendercodeMsg } from '~/api/messages/IGendercodeMsg';

@SignalrListener
@service(GenderManager)
export class GenderManager {
  @inject(GenderStore) protected genderStore: GenderStore;

  find(id?: string) {
    return this.genderStore.find(id);
  }

  get all() {
    return this.genderStore.all();
  }

  @SignalrMessage('GendercodeMsg')
  onGendercodeMsg(response: IGendercodeMsg) {
    this.genderStore.batchUpdate(mapValueProperty(response.gendercodes));
  }
}
